/**
 * DEPARTMENTS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getDepartments,
    getDepartment,
    printDepartment,
    createDepartments,
    updateDepartments,
    deleteDepartments,
} from "Core/configuration/departments/config/api.departments";

const state = {
    page: {},
    form: {},
    departments: [],
    department_options: [],
    selectedDepartment: {
        department_id: null,
        company_id: "",
        department_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        department_details: [],
    },
    departments_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_departments: {
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        department_name: {
            name: "department_name",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        manager_id: {
            name: "manager_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        location_id: {
            name: "location_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        description: {
            name: "description",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        cost_center: {
            name: "cost_center",
            rules: "trim|max_length[50]",
            max_len: "50",
            min_len: "",
            default_value: "",
        },
        budget: {
            name: "budget",
            rules: "trim|max_length[11]|decimal",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        start_date: {
            name: "start_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        end_date: {
            name: "end_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        parent_department_id: {
            name: "parent_department_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    departments: (state) => {
        return state.departments;
    },
};

// actions
const actions = {
    async fetchDepartments({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getDepartments({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageDepartments", response.data.page);
                }

                if (body.options) {
                    commit("setDepartmentOptions", response.data.departments);
                } else {
                    commit("setDepartments", response.data.departments);
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchDepartment({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getDepartment(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedDepartment", response.data.department);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printDepartment({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printDepartment(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveDepartment({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["department_id"] === "undefined" || body["department_id"] == null || body["department_id"] == "") {
                delete body["department_id"];
                response = await createDepartments({ body: body, headers: config.headers });
            } else {
                let department_id = body["department_id"];
                delete body["department_id"];
                response = await updateDepartments({ body: body, headers: config.headers }, department_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteDepartment({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteDepartments(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageDepartments(state, page) {
        state.page = page;
    },
    setDepartments(state, departments) {
        state.departments = departments;
    },
    setDepartmentOptions(state, departments) {
        state.department_options = departments;
    },
    setSelectedDepartment(state, department) {
        state.selectedDepartment = department;
    },
    resetSelectedDepartment(state) {
        for (const key in state.selectedDepartment) {
            if (key in state.rules_departments) {
                state.selectedDepartment[key] = state.rules_departments[key].default_value == "null" ? null : state.rules_departments[key].default_value;
            }
        }
    },
    resetDepartments(state) {
        state.page = {};
        state.form = {};
        state.departments = [];
        state.department_options = [];
        state.selectedDepartment = {
            department_id: null,
            company_id: "",
            department_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            department_details: [],
        };
        state.departments_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
